import { render } from "./VisionBox.vue?vue&type=template&id=7bf0a71e&scoped=true"
import script from "./VisionBox.vue?vue&type=script&lang=js"
export * from "./VisionBox.vue?vue&type=script&lang=js"

import "./VisionBox.vue?vue&type=style&index=0&id=7bf0a71e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf0a71e"]])

export default __exports__